import { useTranslation } from 'react-i18next';

const SwitchLang = ({ previewLang, setPreviewLang, className }) => {
    const { t } = useTranslation();
    return (
        <div className={`flex space-x-2 text-tiny `}>
            <span
                style={{ borderRight: '1px solid #DBDBDB' }}
                onClick={() => {
                    setPreviewLang('TH');
                }}
                className={`${
                    previewLang === 'TH' ? 'text-purple-PHX font-semibold' : ''
                } cursor-pointer hover:opacity-80 pr-2`}
            >
                {t('policy.th')}
            </span>
            <span
                onClick={() => {
                    setPreviewLang('EN');
                }}
                className={`${
                    previewLang === 'EN' ? 'text-purple-PHX font-semibold' : ''
                } cursor-pointer hover:opacity-80`}
            >
                {t('policy.en')}
            </span>
        </div>
    );

};

export default SwitchLang;
